<script setup lang="ts">
import { sizes, stylesButton as styles, type ISizes, type IStyles } from './styles';

interface Props {
  styleName?: IStyles | null | undefined;
  size?: ISizes | null | undefined;
  href?: String | string | undefined;
  type?: 'submit' | 'reset' | 'button' | undefined;
  value?: String | string | undefined;
  target?: '_blank' | '_self' | '_parent' | '_top' | undefined;
  block?: boolean | undefined;
  disabled?: boolean | undefined;
  external?: boolean | undefined;
  rounded?: boolean | undefined;
  noFormat?: boolean | undefined;
  [x: string]: any;
};

const props = withDefaults(defineProps<Props>(), {
  rounded: true,
  type: 'button',
  styleName: 'default'
});

const emit = defineEmits(['click', 'change', 'focus']);
</script>

<template>
  <NuxtLink
    v-if="href"
    :class="[
      ('text-auto'),
      ((! noFormat) && 'flex text-center justify-center items-center border-2 transition'),
      (block ? 'w-full' : 'w-fit'),
      ((size !== undefined) ? sizes[size] : 'padding-auto'),
      (rounded && 'rounded-auto'),
      ((! disabled) && styles[styleName]),
      (disabled && styles['muted'])
    ]"
    :formtarget="target"
    :target="target"
    :disabled="(disabled ? true : undefined)"
    :href="((! disabled) ? href : null)"
    :external="external"
    @click="(e: Event) => ((! disabled) ? emit('click', e) : null)"
    @change="(e: Event) => ((! disabled) ? emit('change', e) : null)"
    @focus="(e: Event) => ((! disabled) ? emit('focus', e) : null)">
    <slot>
      {{ value }}
    </slot>
  </NuxtLink>
  <button
    v-else
    :class="[
      ('text-auto'),
      ((! noFormat) && 'flex text-center justify-center items-center border-2 transition'),
      (block ? 'w-full' : 'w-fit'),
      ((size !== undefined) ? sizes[size] : 'padding-auto'),
      (rounded && 'rounded-auto'),
      ((! disabled) && styles[styleName]),
      (disabled && styles['muted'])
    ]"
    :formtarget="target"
    :target="target"
    :disabled="disabled"
    :type="type"
    :external="external"
    @click="(e: Event) => ((! disabled) ? emit('click', e) : null)"
    @change="(e: Event) => ((! disabled) ? emit('change', e) : null)"
    @focus="(e: Event) => ((! disabled) ? emit('focus', e) : null)">
    <slot>
      {{ value }}
    </slot>
  </button>
</template>

<style lang="scss" scoped></style>
